import React from 'react';
import { Typography } from '@mui/material';
import WhatsAppFormattedText from '../WhatsAppFormattedText';
import MediaMessage from './media/MediaMessage';
import AudioMessageContent from './media/AudioMessageContent';
import ImageMessageContent from './media/ImageMessageContent';
import VideoMessageContent from './media/VideoMessageContent';
import DocumentMessageContent from './media/DocumentMessageContent';
import StickerMessageContent from './media/StickerMessageContent';
import ContactMessageContent from './media/ContactMessageContent';

const MessageContentRenderer = ({ message }) => {
  if (message.hasAudio) {
    return (
      <MediaMessage message={message}>
        <AudioMessageContent media={message.media} messageUuid={message.uuid} />
      </MediaMessage>
    );
  }

  if (message.mediaKind === 'image') {
    return (
      <MediaMessage message={message}>
        <ImageMessageContent media={message.media} messageUuid={message.uuid} />
      </MediaMessage>
    );
  }

  if (message.mediaKind === 'video') {
    return (
      <MediaMessage message={message}>
        <VideoMessageContent media={message.media} messageUuid={message.uuid} />
      </MediaMessage>
    );
  }

  if (message.mediaKind === 'sticker') {
    return (
      <MediaMessage message={message}>
        <StickerMessageContent media={message.media} messageUuid={message.uuid} />
      </MediaMessage>
    );
  }

  if (message.mediaKind === 'document') {
    return (
      <MediaMessage message={message}>
        <DocumentMessageContent media={message.media} messageUuid={message.uuid} />
      </MediaMessage>
    );
  }

  if (message.mediaKind === 'contact') {
    return <ContactMessageContent contact={message.contact} />;
  }

  return (
    <Typography variant="body2" component="div" sx={{ wordBreak: 'break-word' }}>
      <WhatsAppFormattedText text={message.text} />
    </Typography>
  );
};

export default MessageContentRenderer;
